import makeStyles from '@mui/styles/makeStyles';

import { UploadCSVType } from "../../../../../../util/enums";
import { ColumnsValues } from "./getInputColumns";

type StyleProps = {
  columnType: ColumnsValues;
};

const styles = makeStyles(() => ({
  uploadInput: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    margin: 0,
    padding: 0,
    cursor: "pointer",
    width: "max-content",

    "& > span": {
      fontFamily: "Inter",
      fontStyle: "normal",
      fontWeight: 500,
      fontSize: "0.875rem",
      color: "#308CDB",
    },

    "& input": {
      display: "none",
    },
  },
  uploadButton: {
    backgroundColor: "transparent",
    color: "#308CDB",
    border: "1px solid #308CDB",
    borderRadius: 8,

    display: "flex",
    alignItems: "center",
    gap: 14,

    "&:hover": {
      color: "#308CDB",
    },
  },
  mr12: {
    marginRight: 12,
  },
  fileNameButton: {
    backgroundColor: "#F9FAFB !important",
    color: "#465869 !important",
    opacity: "1 !important",
    marginRight: 23,
  },
}));

export default styles;
